module.exports = __webpack_public_path__ + "d85ae6017d6dec607ec48feb8871b6c1.pdf";